module.exports = {"id":"232441","name":"Masaaki Higashiguchi","rating":"72","photo":"./data/images/photos/3/232441.png","club":{"name":"Gamba Osaka","logo":"./data/images/clubs/GambaOsaka.png"},"positions":["G"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MasaakiHigashiguchi0.json
// module id = 2839
// module chunks = 0